import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { useRequestResetPasswordMutation } from '../../../services/dvagent';
import { Toaster } from '../../@dashboard/attributes';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [requsetResetPassword] = useRequestResetPasswordMutation();
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  const handleEmail = (event) => {
    setEmail(event.target.value);
    setEmailError('');
  };

  const handleResetPassword = async () => {
    setEmailError('');
    if (!email) {
      setEmailError('Please enter email');
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setEmailError('Invalid email address');
    }
    if (!email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      return;
    }

    const actualData = { email };

    const res = await requsetResetPassword(actualData);
    if (res.error) {
      if (res.error.status === 400) {
        showToast(false, 'ⓘ', 'Bad Request');
      } else if (res.error.status === 500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }

    if (res.data && res.data.success === true) {
      setEmail('');
      showToast(true, '✔', 'Mail sent. Please check your email and change your password.');
    } else if (res.data) {
      setEmailError('User does not exist');
    }
  };

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Box alignItems="center" justifyContent="center" mx="auto" m={5}>
        <Avatar
          src="../user/default-user.gif"
          sx={{ width: 100, height: 100, margin: 'auto', borderColor: '#A8A196' }}
        />
      </Box>
      <Typography variant="h6" sx={{ marginBottom: '5%' }}>
        Forgot Password?
      </Typography>

      <Typography sx={{ marginBottom: '5%', fontSize: 14 }}>
        Please enter your email address below. We will send you an email to reset your password.
      </Typography>
      <Stack spacing={3}>
        <TextField
          label="Email"
          variant="outlined"
          value={email}
          onChange={handleEmail}
          helperText={emailError}
          error={Boolean(emailError)}
        />
        <Button
          onClick={handleResetPassword}
          sx={{
            color: '#FFF',
            border: 1,
            borderColor: '#A8A196',
            bgcolor: '#A8A196',
            ':hover': {
              bgcolor: '#7D7463',
              borderColor: '#7D7463',
            },
          }}
        >
          Send
        </Button>
      </Stack>
    </>
  );
}